import { DetermineTextColor } from "../utils/DetermineTextColor";
import { enumElementBorderStyle, enumElementDrawStates } from "../constants";
import { QBasicButton } from "./QBasicButton";
import { TruncateText } from "../utils/TruncateText";
import { Globals } from "./Globals";
import { MeasureTextHeight } from "../utils/MeasureTextHeight";
import { MeasureText } from "../utils/MeasureText";
import { SetCtxFont } from "../utils/SetCtxFont";

export class QFALabelButton extends QBasicButton {
  constructor() {
    super();
    this.fFontString = "12px Arial";
    this.fFAStyle = '400 15px "Font Awesome 5 Pro"';
    this.fIconBuffer = 6;
    this.fBorderRadius = 3;
    this.fIconAlign = "center";
  }

  InitButton(parent, cmdCode, x, y, label, fontIcon) {
    this.fWSMgr = parent.GetWSMgrRef();
    this.fUIColors = this.fWSMgr.GetUIColors();
    if (label != null) this.SetLabel(label);
    this.SetFAIcon(fontIcon);
    this.SetCmdCode(cmdCode);
    this.SetBorderStyle(enumElementBorderStyle.roundBorder);
    this.SetBorderColor(this.fUIColors.GetPagingBlueColor());
    this.SetFillColor(this.fUIColors.GetPagingBlueColor());
    this.SetBorderThickness(0);
    this.PositionElement(x, y);
    parent.PushElement(this);
  }

  SetFAIcon(faIcon) {
    this.fFAIcon = faIcon;
  }

  SetFAStyle(faStyle) {
    this.fFAStyle = faStyle;
  }

  SetFAIconColor(color) {
    this.fFontIconColor = color;
  }

  DoRenderContent() {}

  AutoSize() {
    var padding = 10;
    this.fMinW = 22;
    this.fMinH = 20;
    var sizeW = this.fMinW ? this.fMinW : 0;
    var sizeH = this.fMinH ? this.fMinW : 0;
    var labelSize = this.fLabelFontSize != null ? this.fLabelFontSize : 16;
    var labelHeight = MeasureTextHeight(this.fFontString, labelSize);
    var labelLen = this.MeasureLabel() + 35;
    if (this.fFAIcon) {
      var iconHeight = MeasureTextHeight(this.fFAStyle, labelSize, true);
      if (iconHeight > labelHeight) labelHeight = iconHeight;

      labelLen += MeasureText(this.fFAIcon, this.fFAStyle);

      if (labelSize == 1) {
        labelHeight += 2 * padding;
        labelLen += 2 * padding;
      }
    }

    if (labelLen > sizeW) sizeW = labelLen;
    if (labelHeight > sizeH) sizeH = labelHeight;
    this.SizeElement(sizeW, sizeH);
  }

  DrawLabel(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.save();

    var drawState = this.GetDrawState();
    var txtFillStyle =
      this.fTxtFillStyle != null ? this.fTxtFillStyle : DetermineTextColor(this.fFillColor);

    switch (drawState) {
      case enumElementDrawStates.Disabled:
        txtFillStyle = Globals._themeMode.text.disabled;
        break;
    }

    ctx.fillStyle = txtFillStyle;
    var fontString = this.fFontString != null ? this.fFontString : "12px Arial";

    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    var buffer = this.fIconBuffer; // buffer between icon and label in pixels
    var txt = this.fLabel; // string

    var labelText = TruncateText(txt, fontString, this.GetWidth()); // truncate text if exceeds button width
    var yPos = this.fVertOffset + this.fHeight / 2; // yOffset of text vertically centered on button

    var iconWidth = MeasureText(this.fFAIcon, this.fFAStyle); // width of icon in pixels
    var stringWidth = MeasureText(labelText, fontString); // width of string label in pixels

    var totalLabelWidth = iconWidth + buffer + stringWidth; // total width of icon + label + buffer in pixels
    var buttonWidth = this.fWidth; // total button width in pixels

    var iconOffset =
      txt == "" ? Math.floor(buttonWidth / 2) - 5 : Math.floor((buttonWidth - totalLabelWidth) / 2); // offset of total label width in pixels

    var iconX = iconOffset + 5;

    if (this.fIconAlign == "left") {
      buffer = buffer * 2;
      iconX = buffer;
      iconOffset = buffer;
    } else if (this.fIconAlign == "right") {
      buffer = buffer * 2;
      iconX = this.fWidth - iconWidth * 2 - buffer - this.fHorzOffset;
      iconOffset = buffer;
    }
    // iconOffset changes based on whether text is rendered with or without a label.

    var iconXPos = this.fHorzOffset + iconX; // icon uses offset found averaging button width and total label width
    var stringX = this.fHorzOffset + iconOffset + iconWidth + buffer; // string uses icon offset + icon width and buffer

    // draw icon
    if (this.fFontIconColor) ctx.fillStyle = this.fFontIconColor;

    SetCtxFont(ctx, this.fFAStyle);
    ctx.fillText(this.fFAIcon, iconXPos, yPos - 0.5);

    ctx.fillStyle = txtFillStyle;
    // draw label if txt is not '' (default val)
    if (txt != "") {
      ctx.textAlign = "left";
      SetCtxFont(ctx, fontString);
      ctx.fillText(labelText, stringX, yPos);
    }

    ctx.restore();
  }
}
